import React from 'react'
import {css, Global} from '@emotion/react'

import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const createStyles = (hideCloseButton: boolean) => css`
  .osano-cm-dialog {
    a.osano-cm-storage-policy.osano-cm-link,
    ul.osano-cm-dialog__list.osano-cm-list,
    button.osano-cm-button.osano-cm-save {
      display: none;
    }
    font-family: var(--fontFamily);
    ${cssTheme.typography.bodyM};

    border-radius: var(--layout-radius-md);
    margin: auto;
    border: 1px solid ${cssTheme.colors.alert.default.neutral.border};
    background: ${cssTheme.colors.alert.default.neutral.background};
    color: ${cssTheme.colors.alert.default.neutral.content};

    ${linariaMq.desktopXs} {
      margin: ${cssTheme.layout.spacing.s400};
    }

    ${linariaMq.desktopMd} {
      max-width: 1150px;
      margin: ${cssTheme.layout.spacing.s600} auto;
    }

    .osano-cm-link,
    .osano-cm-link:hover,
    .osano-cm-link:active {
      color: ${cssTheme.colors.alert.default.neutral.content};
    }

    .osano-cm-button {
      ${cssTheme.typography.labelM};

      color: ${cssTheme.colors.button.tertiary.default.content};
      background-color: ${cssTheme.colors.button.tertiary.default.background};
      border: 1.5px solid ${cssTheme.colors.button.tertiary.default.border};
      margin: 0 0 ${cssTheme.layout.spacing.s200};
    }

    .osano-cm-dialog__close {
      color: ${cssTheme.colors.alert.default.neutral.content};
      stroke: ${cssTheme.colors.alert.default.neutral.content};
      width: ${hideCloseButton ? '0px' : 'auto'};
      height: ${hideCloseButton ? '0px' : 'auto'};
      visibility: ${hideCloseButton ? 'hidden' : 'visible'};
      opacity: ${hideCloseButton ? '0' : '1'};
      user-select: ${hideCloseButton ? 'none' : 'auto'};
      pointer-events: ${hideCloseButton ? 'none' : 'auto'};
    }

    .osano-cm-dialog__buttons {
      justify-content: center;

      /* Position buttons side by side on mobile for the GDPR template  */
      &:not(:has(.osano-cm-button.osano-cm-manage)) {
        justify-content: space-between;

        .osano-cm-button {
          flex-basis: 48%;
        }
      }

      button.osano-cm-button.osano-cm-manage {
        flex-basis: 100%;
        padding: 0;
        background: none;
        border: none;
        text-align: center;
        text-decoration: underline;
        margin-bottom: ${cssTheme.layout.spacing.s300};
      }
    }

    ${linariaMq.desktopXs} {
      .osano-cm-dialog__buttons {
        justify-content: center;
        &:not(:has(.osano-cm-button.osano-cm-manage)) {
          .osano-cm-button {
            flex-basis: 100%;
          }
        }
      }
    }
  }
`

export const CookieConsentBannerStyles = ({
  hideCloseButton
}: {
  hideCloseButton: boolean
}) => {
  return <Global styles={createStyles(hideCloseButton)} />
}
